import { render, staticRenderFns } from "./InputCalories.vue?vue&type=template&id=46a4408e&scoped=true&"
import script from "./InputCalories.vue?vue&type=script&lang=js&"
export * from "./InputCalories.vue?vue&type=script&lang=js&"
import style0 from "./InputCalories.vue?vue&type=style&index=0&id=46a4408e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a4408e",
  null
  
)

export default component.exports